module.exports = __webpack_public_path__ + "img/EU_SEFdown.319b3cd1.png";